import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCrg-YOQ66fFgONwT-_bYsw_Ro8upj2pqU",
  authDomain: "skylanes-cc1bd.firebaseapp.com",
  projectId: "skylanes-cc1bd",
  storageBucket: "skylanes-cc1bd.firebasestorage.app",
  messagingSenderId: "985522382108",
  appId: "1:985522382108:web:98464f85dcab4a109e86d9",
  measurementId: "G-NFBTDPK9YJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
